// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_labeling_ui_styles" + "." + "ef8b7ffa" + ".chunk.css";
};